import React from 'react';
import classNames from 'classnames';
import styles from '../assets/ServiceLocation-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import dropDownFilter from 'src/components/react-table/filters/dropdown-filter';
import { CellProps } from 'react-table';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IServiceLocation } from 'src/types/service-locations';
import ServiceLocationActionsColumn from './ServiceLocationActionsColumn';
import { QueryParams } from 'src/types/grid';

interface Props {
    data: Paginated<IServiceLocation>;
    getData: (params: QueryParams) => void;
}

const columns: Column<IServiceLocation>[] = [
    {
        Header: 'Name',
        accessor: 'title',
        Filter: textFilter<IServiceLocation>(),
        width: '20%',
    },
    {
        Header: '',
        accessor: 'some',
        Filter: textFilter<IServiceLocation>(),
        disableSortBy: true,
        disableFilters: true,
        width: '70%',
    },
    {
        Header: 'Private',
        accessor: 'isPrivate',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IServiceLocation>) => (original.isPrivate ? <FontAwesomeIcon icon={faCheck} /> : null),
        Filter: dropDownFilter<IServiceLocation>([
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ]),
    },
    {
        Header: 'Actions',
        accessor: 'id',
        Cell: ServiceLocationActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const ServiceLocationsGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<IServiceLocation> columns={columns} data={data} getData={getData} />
    </div>
);

export default ServiceLocationsGrid;
